import React from "react";
import { InputController } from "./InputController";
import { Stack } from "@mui/material";
import SelectController from "./SelectController";

const Step1 = (props) => {
  return (
    <Stack
      direction="column"
      alignItems="center"
      spacing={2}
      sx={{
        width: "450px",
        margin: "auto",
        marginTop: "40px",
        marginBottom: "10px",
      }}
    >
      <InputController
        name="orgName"
        label="Business Name*"
        variant="outlined"
      />
      <SelectController
        name="type"
        label="Business Type*"
        variant="outlined"
      />
      <InputController
        name="desc"
        label="Description*"
        variant="outlined"
        type="multiple"
      />
    </Stack>
  );
};

export { Step1 };
